import {useIntl} from 'react-intl'
import {ProfileInfo} from '../interface'

interface ProfileInfoProps {
    profileInfo: ProfileInfo
}

export const FarmReview = ({profileInfo}: ProfileInfoProps) => {
    const intl = useIntl()
    return (
        <div>
            <h3>{intl.formatMessage({id: 'general.profile_information'})}</h3>
            <p>
                {intl.formatMessage({id: 'register.name'})}: {profileInfo.name}
            </p>
            <p>
                {intl.formatMessage({id: 'register.surname'})}: {profileInfo.surname}
            </p>
            <p>
                {intl.formatMessage({id: 'profile.email'})}: {profileInfo.email}
            </p>
            <p>
                {intl.formatMessage({id: 'profile.publish_email'})}:{' '}
                {intl.formatMessage({
                    id: 'general.' + (profileInfo.publish_email ? 'yes' : 'no'),
                })}
            </p>
            <p>
                {intl.formatMessage({id: 'profile.phone'})}: {profileInfo.phone}
            </p>
            <p>
                {intl.formatMessage({id: 'profile.publish_email'})}:{' '}
                {profileInfo.public_phone}
            </p>

            <h3>{intl.formatMessage({id: 'navigation.company_info'})}</h3>
            <p>
                {intl.formatMessage({id: 'profile.brand'})}: {profileInfo.brand}
            </p>
            <p>
                {intl.formatMessage({id: 'profile.webpage'})}: {profileInfo.website}
            </p>
            <p>
                {intl.formatMessage({id: 'farms.reg_nr'})}: {profileInfo.reg_nr}
            </p>
            <p>
                {intl.formatMessage({id: 'profile.tax_payer_number'})}:{' '}
                {profileInfo.pvn_nr}
            </p>
            <p>
                {intl.formatMessage({id: 'farms.pvd_nr'})} {profileInfo.pvd_nr}
            </p>
            <p>
                {intl.formatMessage({id: 'profile.legal_adress'})}:{' '}
                {profileInfo.legal_adress}
            </p>
            <p>
                {intl.formatMessage({id: 'profile.physical_address'})}:{' '}
                {profileInfo.physical_address}
            </p>

            <h3>{intl.formatMessage({id: 'navigation.added_company_info'})}</h3>

            <p>
                {intl.formatMessage({
                    id: 'profile.participates_in_procurement',
                })}
                :{' '}
                {intl.formatMessage({
                    id:
                        'general.' +
                        (profileInfo.participates_in_procurement ? 'yes' : 'no'),
                })}
            </p>
            <p>
                {intl.formatMessage({id: 'profile.publish_profile'})}:{' '}
                {intl.formatMessage({
                    id: 'general.' + (profileInfo.publish_profile ? 'yes' : 'no'),
                })}{' '}
            </p>
        </div>
    )
}
